<template>
  <div class="bg-home-banner-bg-3-mobile bg-cover w-full flex justify-center">
    <div class="flex flex-col md:flex-row w-full md:w-[1200px] h-auto md:h-auto px-4 py-8 gap-7">
      <!-- Contenedor de la imagen -->
      <div class="flex md:relative rounded-md h-auto md:h-auto w-full md:w-[50%]">
        <img class="flex md:flex h-auto md:h-full w-full md:w-auto aspect-auto rounded-md object-fill"
          :src="'/img/home/battery/nueva_bateria_leon.png'" alt="baterias-nuevas" />
      </div>

      <!-- Contenedor del texto -->
      <div id="battery-info" class="flex flex-col gap-5 md:gap-7 w-full md:w-[50%] text-start md:pl-20">
        <h2 class="text-ROJO_LEON font-bold text-lg md:text-3xl">
          ¿CUÁNDO CAMBIAR UNA BATERÍA DE AUTO?
        </h2>
        <p class="font-bold text-lg">
          Las baterías de automóvil son componentes fundamentales para el
          funcionamiento del vehículo, pero con el tiempo, su rendimiento puede
          deteriorarse. Aquí tienes una guía para identificar cuándo es el
          momento adecuado para cambiar la batería de tu auto.
        </p>
        <NuxtLink :to="`/${NEGOCIOS.BATERIAS}/change`" @click="saveSection"
          class="bg-ROJO_LEON mx-auto md:mx-0 text-white rounded-md hover:bg-VINO_LEON hover:text-white p-2 w-2/3 font-bold transition text-center cursor-pointer">
          Ver Más
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>

import { NEGOCIOS } from "~/constants/negocios";

const saveSection = () => {
  localStorage.setItem("section", "battery-info");
};
</script>